import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {  useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import {
  imgpath,
  imgpathapp
} from "../../Config/config";
import {
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  arrayUnion,
  arrayRemove,
  collection,
  serverTimestamp
} from "firebase/firestore";
import { db } from '../../Config/firebase';
import profileimg from "../../assets/large profileicon.svg";

import {
  openModal,
  closeModal
} from '../../feature/showSlice/showModalSlice';

import CommentReply from './CommentReply';
import { Errormsg } from '../../components/tostifymsg/Errrormsg';

function CommentItem({
  comment,
  replyToComment = true,
  userLoggedIn,
  uidFirebase = null,
  handlerReportAction = () => {}
}) {
  const dispatch = useDispatch();
  const loginuserinfo = useSelector((state) => state.loginuserinfo);
  
  const userprofileimage = Cookies.get("userprofileimage");
  const email = Cookies.get("email");
  const userId = Cookies.get("id");
  const username = Cookies.get("username");

  const [replies, setReplies] = useState(false);

  const handlerLike = async () => {
    if (!validateLoggedIn()) return;

    let hasLiked = comment.likes?.includes(uidFirebase);

    try {
      await updateDoc(doc(db, "MovieComments", comment.id), {
        likes: hasLiked ? arrayRemove(uidFirebase) : arrayUnion(uidFirebase),
      });

      console.log("✅ Like agregado correctamente");
    } catch (error) {
      console.error("❌ Error al dar like:", error);
    }
  }

  const handlerDelete = async () => {
    if (!validateLoggedIn()) return;

    try {
      if(!comment.id) {
        throw new Error('Comment ID is required to delete a comment.');
      }

      await deleteDoc(doc(db, "MovieComments", comment.id));
    } catch(error) {
      console.error("❌ Error submitting reply:", error);
      Errormsg(error.message);
    }

    console.log('Delete comment id ::', comment.id);
  }

  const handleReply = () => {
    if (!validateLoggedIn()) return;

    setReplies(true);
  }

  const validateLoggedIn = () => {
    if (!userLoggedIn) {
      dispatch(openModal());

      return false;
    }

    return true;
  }

  const handleSubmitReply = (replyContent) => {
    if (!validateLoggedIn()) return;

    try {
      if(!comment.id) {
        throw new Error('Comment ID is required to submit a reply.');
      }

      const dateNowServer = serverTimestamp();
      let imageProfileUrl = `${imgpathapp}` + (
        typeof userprofileimage === 'undefined' || 
        userprofileimage === 'undefined' || 
        userprofileimage === null 
        ? `${profileimg}` : 
          `${userprofileimage}`);

      const replyData = {
        comment: replyContent,
        createdAt: dateNowServer,
        isAdmin: false,
        likes: [],
        movieId: comment.movieId,
        parentCommentId: comment.id,
        reportsIds: [],
        updatedAt: dateNowServer,
        userEmail: email,
        userGafferId: userLoggedIn,
        userId: uidFirebase,
        username: username,
        userProfileUrl: imageProfileUrl
      };

      addDoc(collection(db, "MovieComments"), replyData);

      setReplies(false);
    } catch(error) {
      console.error("❌ Error submitting reply:", error);
      Errormsg(error.message);
    }
  }

  return (
    <>
      <div key={comment.id} className="comment">
        <div className="comment-header">
          <div className="avatar">
            <img src={comment.userProfileUrl} alt="" srcset="" />
          </div>

          <div className="comment-meta">
            <p>{comment.username}</p>
            <span>{moment.tz(comment?.createdAt?.toDate(), "UTC").fromNow()}</span>
          </div>

          { userLoggedIn && (
            <div className="comment-options dropdown">
              <button
                className="btn btn-secondary dropdown-toggle"
                type="button"
                id={`dropdownMenuButtonComment-${comment.id}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
              </button>
              
              <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButtonComment-${comment.id}`}>
                { userLoggedIn && userLoggedIn === comment.userGafferId && (
                    <li>
                      <button onClick={handlerDelete} className="dropdown-item" href="#"><i className="fa fa-trash" aria-hidden="true"></i> Delete</button>
                    </li>
                  )
                }

                { userLoggedIn && userLoggedIn !== comment.userGafferId && (
                    <li>
                      <button onClick={() => handlerReportAction(comment.id)} className="dropdown-item" href="#"><i className="fa fa-flag" aria-hidden="true"></i> Report</button>
                    </li>
                  )
                }
              </ul>
            </div>
          )}
          

        </div>

        <div className="comment-body">
          <p>{comment.comment}</p>
        </div>

        <div className="comment-actions">
          <button onClick={handlerLike} className="like-button">
            { comment.likes?.includes(uidFirebase) ? (
                <i className="fa fa-heart" aria-hidden="true" style={{ color: '#E42855' }}></i>
              ) : (
                <i className="fa fa-heart-o" aria-hidden="true"></i>
              )

            } { comment.likes?.length || 0 } Likes
          </button>
          
          { replyToComment && (
            <button onClick={handleReply} className="replies-button">
              <i className="fa fa-comment-o" aria-hidden="true"></i> { comment.subComments?.length || 0 } Replies
            </button>
          )
          }
        </div>
      </div>

      { comment.subComments && comment.subComments.length > 0 && (
        <div className="sub-comments">
          { comment.subComments.map(subComment => (
              <CommentItem 
                key={subComment.id} 
                comment={subComment} 
                userLoggedIn={userLoggedIn} 
                replyToComment={false} 
                uidFirebase={uidFirebase || null}
                handlerReportAction={(e) => handlerReportAction(e)}
              />
            ))
          }
        </div>
      )}

      { replyToComment && replies && (
        <CommentReply 
          image={
            loginuserinfo?.userprofileimage == undefined
              ? imgpath + userprofileimage
              : imgpath + loginuserinfo?.userprofileimage
          }
          errorImage={profileimg}
          handleSubmitReply={(e) => handleSubmitReply(e)} 
          setReplies={setReplies}
        />
      )}
    </>
  );
}

export default CommentItem;